// A 404 here means "there isn't one yet", which every caller renders as
// an empty state rather than an error.
export const notFoundToNull = async <T>(
  fetch: () => Promise<T>,
): Promise<T | null> => {
  try {
    return await fetch();
  } catch (error: any) {
    if (error.response?.status === 404) {
      return null;
    }
    throw error;
  }
};
